import type { GridMapboxStyle } from './styles';

export const gridsBlock = (style: GridMapboxStyle) => [
  {
    minzoom: 9,
    layout: {
      'text-field': ['get', 'label'],
      'text-size': style.textSize,
      'text-ignore-placement': false,
      'text-allow-overlap': false,
      visibility: 'visible',
    },
    type: 'symbol',
    id: 'nts-block-labels',
    paint: {
      'text-color': style.textColor,
      ...(style.textHaloColor &&
        style.textHaloWidth && {
          'text-halo-color': style.textHaloColor,
          'text-halo-width': style.textHaloWidth,
        }),
    },
    source: 'grids',
    'source-layer': 'block_centers',
  },
  {
    id: 'nts-block-grid',
    minzoom: 9,
    type: 'line',
    paint: {
      'line-color': style.lineColor,
      'line-width': style.lineWidth,
    },
    source: 'grids',
    'source-layer': 'block',
    layout: {
      visibility: 'visible',
    },
  },
];
